module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06foreword#for"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06foreword#for"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#ing"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Basic Ingredients")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#ing"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Almonds")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Almond Butter")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Almond Flour or Meal (Ground Almonds)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Almond Milk")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Brown Rice Syrup")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev6"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cacao Powder (Raw) and Cocoa Powder")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg8lev6"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg9lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cashews")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg9lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg9lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Coconut")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg9lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg9lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Coconut Flour")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg9lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg9lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Coconut Nectar")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg9lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg9lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Coconut Palm Sugar")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg9lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg10lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Dark Chocolate")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg10lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg10lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Dates")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg10lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg10lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Maple Syrup, Pure")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg10lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg10lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Oats, Gluten-Free Rolled")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07basic#pg10lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#tec"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Tools and Techniques")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#tec"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Essential Tools")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Multispeed Food Processor")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Large Mixing Bowl")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Large Plates or Small Baking Sheets")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev6"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Spatula")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev6"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev7"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Refrigerator and Freezer")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg11lev7"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg12lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Techniques")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg12lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg12lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Processing")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg12lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg12lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Shaping")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg12lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg12lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Coating")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg12lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg12lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Storage")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08tools#pg12lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09special#die"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Special Diets")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09special#die"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Diabetes/Low-Glycemic Diet")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Grain-free")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Paleolithic/Primal")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Peanut/Nut-free")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev6"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Pregnancy")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev6"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev7"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Soy-free")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09special#pg13lev7"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tocq"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10part01#part1"
    }
  }, [_c('span', {
    staticClass: "display_type"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Breakfast")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocq"
  }, [_c('span', {
    staticClass: "display_type1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10part01#part1"
    }
  }, [_c('span', {
    staticClass: "gray1"
  }, [_vm._v("Energy Balls")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10part01#part1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Breakfast Energy Balls Active Ingredients")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Apples")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Blueberries")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Chia Seeds")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cinnamon")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev6"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Flaxseed, Ground (Flax Meal)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev6"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev7"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Granola")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg16lev7"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg17lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Lemons")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg17lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg17lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Maple Sugar")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg17lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg17lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Peaches")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg17lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg17lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Pecans")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg17lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg17lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Raisins")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12part01b#pg17lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13part01chapter01#pg18lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Banana Bread")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13part01chapter01#pg18lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14part01chapter02#pg20lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Apple Pie and Almond Butter")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14part01chapter02#pg20lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15part01chapter03#pg22lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Maple, Pecan, and Oatmeal")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15part01chapter03#pg22lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/16part01chapter04#pg24lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cranberry-Chocolate Granola")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/16part01chapter04#pg24lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/17part01chapter05#pg26lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Lemon, Almond, and Chia Muffin")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17part01chapter05#pg26lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/18part01chapter06#pg28lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cinnamon–Raisin")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/18part01chapter06#pg28lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/19part01chapter07#pg30lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Blueberry Muffin")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/19part01chapter07#pg30lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/20part01chapter08#pg32lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Peach Cobbler")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/20part01chapter08#pg32lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/21part01chapter09#pg34lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Raisin–Bran")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/21part01chapter09#pg34lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("34")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tocq"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/22part02#part2"
    }
  }, [_c('span', {
    staticClass: "display_type"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Lunch-Box")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocq"
  }, [_c('span', {
    staticClass: "display_type1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/22part02#part2"
    }
  }, [_c('span', {
    staticClass: "gray1"
  }, [_vm._v("Energy Balls")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/22part02#part2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("36")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg38lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Lunch-Box Energy Balls Active Ingredients")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg38lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg38lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Brown Rice Crisp Cereal (Puffed Brown Rice)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg38lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg38lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Buckwheat Groats")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg38lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg38lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Figs")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg38lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg38lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Natural Fruit Jelly or Jam")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg38lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg39lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Popcorn")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg39lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg39lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Strawberries")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg39lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg39lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Sunflower-Seed Butter")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg39lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg39lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Unsulfured Molasses")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/24part02b#pg39lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/25part02chapter01#pg40lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Gingerbread–Dark Chocolate")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/25part02chapter01#pg40lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/26part02chapter02#pg42lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cocoa Crispy Rice")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/26part02chapter02#pg42lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/27part02chapter03#pg44lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Oatmeal and Raisin Cookie")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/27part02chapter03#pg44lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/28part02chapter04#pg46lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Strawberry Shortcake")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/28part02chapter04#pg46lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/29part02chapter05#pg48lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Peanut Butter and Jelly")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/29part02chapter05#pg48lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/30part02chapter06#pg50lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Sweet-and-Salty Popcorn")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/30part02chapter06#pg50lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/31part02chapter07#pg52lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Fig and Almond")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/31part02chapter07#pg52lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/32part02chapter08#pg54lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Peanut Butter and Chocolate")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/32part02chapter08#pg54lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/33part02chapter09#pg56lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Apricot, Coconut, and Seeds")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/33part02chapter09#pg56lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("56")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar2"
  }, [_c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tocq"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/34part03#part3"
    }
  }, [_c('span', {
    staticClass: "display_type"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Brain-Boosting")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocq"
  }, [_c('span', {
    staticClass: "display_type1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/34part03#part3"
    }
  }, [_c('span', {
    staticClass: "gray1"
  }, [_vm._v("Energy Balls")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/34part03#part3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("58")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Brain-Boosting Energy Balls Active Ingredients")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Avocado")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Bananas (Whole Natural Dried)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Brazil Nuts")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Coffee")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev6"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Dried Super Fruits")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg60lev6"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg61lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Masala Chai Tea Powder")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg61lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg61lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Matcha")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg61lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg61lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Spirulina Powder")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg61lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg61lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Walnuts")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/36part03b#pg61lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/37part03chapter01#pg62lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Hazelnut–Super Fruit")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/37part03chapter01#pg62lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/38part03chapter02#pg64lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Chocolate Chip and Banana")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/38part03chapter02#pg64lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/39part03chapter03#pg66lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Lemon and Brazil Nut")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/39part03chapter03#pg66lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/40part03chapter04#pg68lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Chocolate, Almond, and Sea Salt")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/40part03chapter04#pg68lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/41part03chapter05#pg70lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Mocha–Walnut")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/41part03chapter05#pg70lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/42part03chapter06#pg72lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Matcha, Mint, and Chocolate")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/42part03chapter06#pg72lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/43part03chapter07#pg74lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Vanilla Chai Latte")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/43part03chapter07#pg74lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/44part03chapter08#pg76lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Chocolate, Almond, and Avocado")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/44part03chapter08#pg76lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/45part03chapter09#pg78lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Spirulina and Hemp")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/45part03chapter09#pg78lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("78")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar3"
  }, [_c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-04.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tocq"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/46part04#part4"
    }
  }, [_c('span', {
    staticClass: "display_type"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Performance-Enhancing")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocq"
  }, [_c('span', {
    staticClass: "display_type1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/46part04#part4"
    }
  }, [_c('span', {
    staticClass: "gray1"
  }, [_vm._v("Energy Balls")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/46part04#part4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("80")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg82lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Performance-Enhancing Energy Balls Active Ingredients")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg82lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg82lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Apricots")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg82lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg82lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Carrots")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg82lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg82lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cashew Butter")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg82lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg82lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Chickpeas")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg82lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg83lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Hazelnuts")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg83lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg83lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Hemp Seeds")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg83lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg83lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Sea Salt")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg83lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg83lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Vegan Protein Powder")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/48part04b#pg83lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/49part04chapter01#pg84lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Pumpkin Pie")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/49part04chapter01#pg84lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/50part04chapter02#pg86lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Double-Chocolate Fudge")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/50part04chapter02#pg86lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/51part04chapter03#pg88lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Chocolate–Hazelnut")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/51part04chapter03#pg88lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/52part04chapter04#pg90lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Apricot and Cashew")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/52part04chapter04#pg90lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/53part04chapter05#pg92lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Toasted Coconut Fudge")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/53part04chapter05#pg92lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("92")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/54part04chapter06#pg94lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cookie Dough")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/54part04chapter06#pg94lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/55part04chapter07#pg96lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Carrot Cake")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/55part04chapter07#pg96lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/56part04chapter08#pg98lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Vanilla Cake")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/56part04chapter08#pg98lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/57part04chapter09#pg100lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Salted Caramel and Chia")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/57part04chapter09#pg100lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar4"
  }, [_c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-05.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tocq"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/58part05#part5"
    }
  }, [_c('span', {
    staticClass: "display_type"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Bedtime")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocq"
  }, [_c('span', {
    staticClass: "display_type1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/58part05#part5"
    }
  }, [_c('span', {
    staticClass: "gray1"
  }, [_vm._v("Energy Balls")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/58part05#part5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("102")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg104lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Bedtime Energy Balls Active Ingredients")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg104lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg104lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cherries")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg104lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg104lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cranberries")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg104lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg104lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Ginger")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg104lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg104lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Limes")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg104lev5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg105lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Maca Powder")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg105lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg105lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Oranges")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg105lev2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg105lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Pistachios")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg105lev3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg105lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Red Pepper (Chili) Flakes")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/60part05b#pg105lev4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/61part05chapter01#pg106lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cashew, Cranberry, and Coconut")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/61part05chapter01#pg106lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/62part05chapter02#pg108lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Ginger, Pear, and Pistachio")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/62part05chapter02#pg108lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("108")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/63part05chapter03#pg110lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Chocolate–Orange")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/63part05chapter03#pg110lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/64part05chapter04#pg112lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Chocolate–Almond Truffles")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/64part05chapter04#pg112lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("112")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/65part05chapter05#pg114lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Double-Chocolate and Cherry")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/65part05chapter05#pg114lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("114")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/66part05chapter06#pg116lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Lime and Coconut")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/66part05chapter06#pg116lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("116")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/67part05chapter07#pg118lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Ginger and Graham Cracker Crumble")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/67part05chapter07#pg118lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/68part05chapter08#pg120lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("White Chocolate, Maple, and Chili")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/68part05chapter08#pg120lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/69part05chapter09#pg122lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Ginger, Mango, and Maca")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/69part05chapter09#pg122lev1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("122")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/70resources#res"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/70resources#res"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("124")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/71index#ind"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Index")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/71index#ind"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/72acknowledgments#ack"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/72acknowledgments#ack"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("128")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64733c10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05-contents.vue
// module id = 69
// module chunks = 0